/**
 * UI Slice
 *
 * State and actions for mobile, toasts, and theme.
 */

import type { StateCreator } from 'zustand';
import type { ThemeMode, ThemePalette } from '@/components/modals/SettingsModal';
import type { AppStore, UiSlice } from '../types';

const MAX_TOASTS = 10;

export const createUiSlice: StateCreator<AppStore, [], [], UiSlice> = (set) => ({
  isMobile:
    typeof window !== 'undefined' && window.matchMedia
      ? window.matchMedia('(max-width: 1024px)').matches
      : false,
  isMobileSidebarOpen: false,
  toasts: [],
  theme: (() => {
    if (typeof window === 'undefined') return 'dark';
    const saved = localStorage.getItem('zenda-theme');
    return (saved as ThemeMode) || 'dark';
  })(),
  palette: (() => {
    if (typeof window === 'undefined') return 'violet';
    const saved = localStorage.getItem('zenda-palette');
    return (saved as ThemePalette) || 'violet';
  })(),
  searchFocusTrigger: 0,

  setIsMobile: (isMobile) => {
    set({ isMobile });
    if (!isMobile) {
      set({ isMobileSidebarOpen: false });
    }
  },

  setMobileSidebarOpen: (open) => set({ isMobileSidebarOpen: open }),

  addToast: (message, type = 'info', duration = 4000, action, undoId) => {
    const id = `toast-${Date.now()}-${Math.random()}`;
    const newToast = { id, message, type, duration, action, undoId };
    set((state) => ({
      toasts: [...state.toasts, newToast].slice(-MAX_TOASTS),
    }));
  },

  removeToast: (id) => {
    set((state) => ({
      toasts: state.toasts.filter((toast) => toast.id !== id),
    }));
  },

  setTheme: (theme) => set({ theme }),
  setPalette: (palette) => set({ palette }),
  triggerSearchFocus: () => set((state) => ({ searchFocusTrigger: state.searchFocusTrigger + 1 })),
});
